import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../PageHeader';
import CorporateSectionLayout from '../CorporateSectionLayout';
import ProyekStrategisNasional from './ProyekStrategisNasional';
import PalapaRingTengahDetail from './PalapaRingTengahDetail';
import LokasiDanWilayah from './LokasiDanWilayah';

function PalapaRingLayout() {
    const items = [
        { id: 'proyek-strategis-nasional', number: '01', label: 'Proyek Strategis Nasional', content: <ProyekStrategisNasional />, surface: false },
        { id: 'palapa-ring-tengah', number: '02', label: 'Palapa Ring Tengah', content: <PalapaRingTengahDetail />, surface: false },
        { id: 'lokasi-dan-wilayah', number: '03', label: 'Lokasi dan Wilayah', content: <LokasiDanWilayah />, surface: false },
    ];

    return (
        <>
            <Helmet>
                <title>Palapa Ring Tengah | PT Len Telekomunikasi Indonesia</title>
                <meta name="description" content="Informasi Palapa Ring Paket Tengah, proyek strategis nasional untuk pemerataan konektivitas digital Indonesia oleh PT Len Telekomunikasi Indonesia." />
                <link rel="canonical" href="https://www.len-telko.co.id/palapa-ring" />
            </Helmet>
            <PageHeader title="Palapa Ring" />
            <CorporateSectionLayout title="Palapa Ring" items={items} />
        </>
    );
}

export default PalapaRingLayout;
